/**
 * @lodex-pro/web-portal/auth/SignInPage — sign-in page.
 *
 * The shared sign-in screen (web-shared SignInScreen, 2026-10-21: "All sign in screens should be
 * the same"): email + password, MFA, "Forgot your password?" (D7: a phone-first pumper sets their
 * web password here) and the forced new password (DEC-152).
 *
 * DEC-159 — pool-aware: `usePortalTenantType()` picks the name ("lodeX Pro Operator Portal" or
 * "lodeX Pro Disposal Portal") and where sign-in lands. DEC-153 — react-router's navigate().
 *
 * Touch targets ≥ 56px: the portals are used on tablets in the field (design/auth.css).
 */

import { useNavigate } from 'react-router-dom';
import { SignInScreen } from '@lodex-pro/web-shared';
import type { FC } from 'react';

import { usePortalTenantType } from './tenant-type-context';

export interface SignInPageProps {
  readonly onSignedIn?: () => void;
  readonly onTotpSetupRequired?: () => void;
}

export const SignInPage: FC<SignInPageProps> = ({ onSignedIn, onTotpSetupRequired }) => {
  const navigate = useNavigate();
  const tenantType = usePortalTenantType();
  const appName = `lodeX Pro ${tenantType === 'disposal' ? 'Disposal Portal' : 'Operator Portal'}`;
  const postSignInTarget = tenantType === 'disposal' ? '/portal/disposal' : '/portal/operator';
  return (
    <SignInScreen
      appName={appName}
      onSignedIn={() => {
        if (onSignedIn !== undefined) {
          onSignedIn();
          return;
        }
        void navigate(postSignInTarget, { replace: true });
      }}
      onTotpSetupRequired={() => {
        if (onTotpSetupRequired !== undefined) {
          onTotpSetupRequired();
          return;
        }
        // The setup UI is pool-agnostic, so both tenant types share the URL (DEC-159).
        window.location.assign('/auth/totp-setup');
      }}
    />
  );
};
